import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { Redirect } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import { timestampToDate, getFullDateAsString } from '../../utils/DateUtil';
import M from 'materialize-css';

const ExportSnapshots = (props) => {
  const { firestore, auth } = props;
  const [snapshots, setSnapshots] = useState([]);
  const [exportData, setExportData] = useState([]);

  useEffect(() => getTemporarySnapshots(firestore), [firestore]);

  useEffect(() => generateData(snapshots), [snapshots]);

  const getTemporarySnapshots = (firestore) => {
    firestore
      .collection('profileTemporarySnapshot')
      .get()
      .then((querySnapshot) => {
        const snapshots = querySnapshot.docs.map((doc) => doc.data());
        setSnapshots(snapshots);
      })
      .catch((e) => {
        M.toast({ html: e.message });
      });
  };

  const generateData = (snapshots) => {
    const data = snapshots.map((snapshot) => ({
      ...snapshot,
      errors: snapshot.errors.join(),
      birthDate: timestampToDate(snapshot.birthDate),
      updatedAt: timestampToDate(snapshot.updatedAt),
    }));
    setExportData(data);
  };

  const deleteSnapshots = () => {
    firestore
      .collection('profileTemporarySnapshot')
      .get()
      .then((snapshot) => {
        const promises = snapshot.docs.map((doc) => doc.ref.delete());
        return Promise.all(promises);
      })
      .then(() => {
        M.toast({ html: 'Snapshots deleted' });
        setSnapshots([]);
        return true;
      })
      .catch((e) => M.toast({ html: e && e.message ? e.message : e }));
  };

  const renderButtons = () => (
    <div className="row">
      <CSVLink className="col s3 waves-effect waves-light btn-small" data={exportData} filename={`ProfileTemporarySnapshots_${getFullDateAsString()}.csv`} disabled={snapshots.length === 0}>
        Export data to CSV
      </CSVLink>
      <button className="col s3 waves-effect waves-light btn-small" style={{ marginLeft: 10 }} onClick={() => deleteSnapshots()} disabled={snapshots.length === 0}>
        Delete all snapshots
      </button>
    </div>
  );

  const renderSnapshots = () =>
    snapshots.length > 0 && (
      <div>
        <div className="row">
          <div className="col s4">Email</div>
          <div className="col s4">Errors</div>
        </div>
        {snapshots.map((snapshot) => (
          <ProfileSnapshot key={snapshot.id} snapshot={snapshot} />
        ))}
      </div>
    );
  const ProfileSnapshot = ({ snapshot }) => (
    <div className="row" style={{ backgroundColor: '#f8f8f8', padding: 10, marginBottom: 5 }}>
      <div className="col s4">{snapshot.email}</div>
      <div className="col s4">{snapshot.errors.join()}</div>
    </div>
  );

  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="container">
      <div className="title-section">Profile temporary snapshots</div>
      {renderButtons()}
      {renderSnapshots()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect(), connect(mapStateToProps))(ExportSnapshots);
